export default "__VITE_ASSET__DtutGBG6__"